// src/constants/icons.ts
import promptIcon from '../assets/icons/prompt-icon.svg'
import responseIcon from '../assets/icons/response-icon.svg'
import altArrowLeft from '../assets/icons/alt-arrow-left.svg'
import altArrowRight from '../assets/icons/alt-arrow-right.svg'
import userCircle from '../assets/icons/user-circle.svg'
import sendIcon from '../assets/icons/send-icon.svg'
import copyIcon from '../assets/icons/copy-icon.svg'
import userRole from '../assets/icons/user-role.svg'
import refreshIcon from '../assets/icons/refresh-icon.svg'
import saveIcon from '../assets/icons/save-icon.svg'
import menuIcon from '../assets/icons/menu.svg'

import addIcon from '../assets/icons/add-icon.svg'
import modelsIcon from '../assets/icons/models.svg'
import tokensIcon from '../assets/icons/tokens.svg'
import editIcon from '../assets/icons/edit.svg'
import validIcon from '../assets/icons/valid.svg'
import thinkIcon from '../assets/icons/think.svg'
import inputTokensIcon from '../assets/icons/input-tokens.svg'
import outputTokensIcon from '../assets/icons/output-tokens.svg'
import totalTokensIcon from '../assets/icons/total-tokens.svg'
import cacheTokensIcon from '../assets/icons/cache-tokens.svg'
import shareIcon from '../assets/icons/share-icon.svg'
import laptopIcon from '../assets/icons/laptop.svg'
import moonIcon from '../assets/icons/moon.svg'
import loginIcon from '../assets/icons/login.svg'
import logoutIcon from '../assets/icons/logout.svg'
import archiveIcon from '../assets/icons/archive.svg'
import folderIcon from '../assets/icons/folder.svg'
import folderPlusIcon from '../assets/icons/folder-plus.svg'
import pinIcon from '../assets/icons/pin.svg'
import pinOffIcon from '../assets/icons/pin-off.svg'
import historyIcon from '../assets/icons/history.svg'
import sunIcon from '../assets/icons/sun.svg'
import brainIcon from '../assets/icons/brain.svg'
import imageAttachmentIcon from '../assets/icons/image-attachment-icon.svg'
import stepsIcon from '../assets/icons/steps.svg'
import linkIcon from '../assets/icons/link.svg'
import gitForkIcon from '../assets/icons/git-fork.svg'

export const ICONS = {
    EDIT: editIcon,
    PROMPT_ICON: promptIcon,
    RESPONSE_ICON: responseIcon,
    ALT_ARROW_LEFT: altArrowLeft,
    ALT_ARROW_RIGHT: altArrowRight,
    USER_CIRCLE: userCircle,
    SEND: sendIcon,
    COPY: copyIcon,
    USER_ROLE: userRole,
    REFRESH_ICON: refreshIcon,
    SAVE_ICON: saveIcon,
    MENU: menuIcon,
    PLUS: addIcon,
    MODELS: modelsIcon,
    TOKENS: tokensIcon,
    VALID: validIcon,
    THINK: thinkIcon,
    INPUT_TOKENS: inputTokensIcon,
    OUTPUT_TOKENS: outputTokensIcon,
    TOTAL_TOKENS: totalTokensIcon,
    CACHE_TOKENS: cacheTokensIcon,
    SHARE: shareIcon,
    LAPTOP: laptopIcon,
    MOON: moonIcon,
    SUN: sunIcon,
    LOGIN: loginIcon,
    LOGOUT: logoutIcon,
    ARCHIVE: archiveIcon,
    FOLDER: folderIcon,
    FOLDER_PLUS: folderPlusIcon,
    PIN: pinIcon,
    PIN_OFF: pinOffIcon,
    HISTORY: historyIcon,
    BRAIN: brainIcon,
    IMAGE_ATTACHMENT: imageAttachmentIcon,
    STEPS: stepsIcon,
    LINK: linkIcon,
    GIT_FORK: gitForkIcon,
}
